import type { Breadcrumb } from '@sentry/react'

const contem = (valor: unknown, trecho: string): boolean =>
  typeof valor === 'string' && valor.includes(trecho)

// UID DICOM: 5 ou mais componentes, ou o 2.25.<número longo> que a plataforma gera. Assim não pega
// número de versão (1.2.3).
const REGEX_UID = /\b\d+(\.\d+){4,}\b|\b\d+\.\d+\.\d{10,}\b|StudyInstanceUID/

const textoDoConsole = (breadcrumb: Breadcrumb): string => {
  let argumentos = ''
  try {
    argumentos = JSON.stringify(breadcrumb.data?.arguments ?? '')
  } catch {
    // Argumento que não serializa (ex.: circular) não tem como ser conferido: descarta.
    return '/dicomweb/'
  }
  return `${breadcrumb.message ?? ''} ${argumentos}`
}

/** Tira do Sentry as URLs do viewer DICOM: levam o id do atendimento e o UID do estudo. */
export const filtrarBreadcrumb = (breadcrumb: Breadcrumb): Breadcrumb | null => {
  const { category, data } = breadcrumb
  if ((category === 'xhr' || category === 'fetch') && contem(data?.url, '/dicomweb/')) return null
  if (category === 'navigation' && (contem(data?.to, '/viewer/') || contem(data?.from, '/viewer/')))
    return null
  if (category === 'console') {
    const texto = textoDoConsole(breadcrumb)
    if (texto.includes('/dicomweb/') || texto.includes('/viewer/') || REGEX_UID.test(texto))
      return null
  }
  return breadcrumb
}
